import DiscountPopupWrapper from "./DiscountPopup.style";
import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { withTranslation } from "react-i18next";
import * as globalUtils from "../../../../helpers/utils";
import { useSelector } from "react-redux";

const DiscountPopup = (props) => {
  const { show = false, t, onPopupClose = () => false } = props;
  const [displayResponsive, setDisplayResponsive] = useState(show);

  useEffect(() => setDisplayResponsive(show), [show]);

  const onPopupHide = () => {
    setDisplayResponsive(false);
    onPopupClose();
  };
  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;

  return (
    <Dialog
      visible={displayResponsive}
      onHide={onPopupClose}
      breakpoints={{ "960px": "75vw" }}
      showHeader={false}
      closable={false}
      className="overflow-hidden"
      contentClassName="p-0"
      modal={true}
      style={{ color: businessColor }}
    >
      <DiscountPopupWrapper>
        <div className="p-4">
          <div className="row">
            <div className="col-sm-12">
              <h2
                className={
                  businessLine
                    ? `headerTitle-${businessLine} headerTitle text-center mb-4`
                    : "headerTitle text-center mb-4"
                }
              >
                {t("congratulations")}!
              </h2>
              <p className="text-center mb-4">
                {t("earn-discount-1")}{" "}
                <span dir="ltr" className="lato">
                  {props.discountValue}%
                </span>{" "}
                {t("earn-discount-2")}
              </p>
            </div>
            <div className="col-12 text-center">
              <Button
                onClick={() => onPopupHide()}
                label={t("ok")}
                style={{ backgroundColor: businessColor }}
              />
            </div>
          </div>
        </div>
      </DiscountPopupWrapper>
    </Dialog>
  );
};

export default withTranslation()(DiscountPopup);
